import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HouseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"house"}/>
}
